import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core'
import { PropertyFilter, PropertyService } from '../property.service'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { ProcessPlanService } from '../../process/process-plans/process-plan.service'
import { WorkItem } from '../../orders/work-items/work-item'
import { ElderFormFieldLabelDirective, Pageable } from '@elderbyte/ngx-starter'
import { Property } from '../property'
import { JsonMap } from '../../orders/work-orders/work-order'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe, KeyValuePipe } from '@angular/common'

@Component({
  selector: 'app-property-display',
  templateUrl: './property-display.component.html',
  styleUrls: ['./property-display.component.scss'],
  imports: [
    MatFormField,
    ElderFormFieldLabelDirective,
    MatLabel,
    MatInput,
    AsyncPipe,
    KeyValuePipe,
  ],
})
export class PropertyDisplayComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _workItem$ = new BehaviorSubject<WorkItem>(null)

  public readonly displayProperties$ = new BehaviorSubject<Map<string, string>>(null)

  private processPlanService = inject(ProcessPlanService)
  private propertyService = inject(PropertyService)

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  // TODO optimize calls?
  public ngOnInit(): void {
    this.processPlanService.findById(this.workItem.processPlanId).subscribe({
      next: (plan) =>
        this.propertyService.resolve(plan.displayProperties, this.workItem.id).subscribe({
          next: (resolved) => {
            this.propertyService
              .findAllPaged(new Pageable(0, 20), [PropertyFilter.ids(plan.displayProperties)])
              .subscribe({
                next: (props) =>
                  this.displayProperties$.next(
                    this.replaceIdWithDescription(resolved, props.content)
                  ),
                error: (err) => this.log.error('Could not load properties!', err),
              })
          },
          error: (err) => this.log.error('Could not build resolve properties!', err),
        }),
      error: (err) => this.log.error('Could not find Process Plan!', err),
    })
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get workItem(): WorkItem {
    return this._workItem$.getValue()
  }

  @Input()
  public set workItem(item: WorkItem) {
    this._workItem$.next(item)
  }

  public get displayProperties(): Map<string, string> {
    return this.displayProperties$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private replaceIdWithDescription(
    resolved: JsonMap<string>,
    props: Property[]
  ): Map<string, string> {
    const propsWithDescription = new Map<string, string>()

    Object.keys(resolved).map((k) => {
      const v = resolved[k]
      const desc = props.find((p) => p.id === k)
      propsWithDescription.set(desc ? desc.description : k, v)
    })

    return propsWithDescription
  }
}
